module.exports = __webpack_public_path__ + "img/12.04e5207b.png";